import { makeStyles } from "@material-ui/core/styles";


const IMAGE_WIDTH = 312;

interface HoverImageProps {
    thumbnailBoundingBox: DOMRect,
}

export default makeStyles((theme) => ({
    hoverDateTime: {
        width: "100%",
        padding: "0.5em",
        textAlign: "center",
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.primary.contrastText,
    },
    hoverImage: {
        width: IMAGE_WIDTH,
        display: "flex",
        flexDirection: "column",
        zIndex: 100,
        position: "fixed",
        bottom: ({ thumbnailBoundingBox }: HoverImageProps) => `calc(100vh - ${thumbnailBoundingBox.top}px + 8px)`,
        left: ({ thumbnailBoundingBox }: HoverImageProps) => {
            const maxLeft = window.innerWidth - IMAGE_WIDTH - 48;
            const left = thumbnailBoundingBox.left - (IMAGE_WIDTH - (thumbnailBoundingBox.width)) / 2;

            return Math.min(left, maxLeft);
        },
    },
}));
